<template>
  <div ref="container">
    <svg ref="svg" class="x-axis"></svg>
  </div>
</template>

<script>
import * as d3 from "d3";
export default {
  name: "XAxis",
  data() {
    return {
      width: 200,
      height: 20,
    };
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    domain: {
      type: Array,
      default: () => [0, 100],
    },
    tickValues: {
      type: Array,
      default: null,
    },
    highlightValue: {
      type: Number,
      default: null,
    },
  },
  mounted() {
    this.setSize();
    this.create();

    if (ResizeObserver) {
      this.resizeObserver = new ResizeObserver(() => {
        this.resize();
      });
      this.resizeObserver.observe(this.$refs.container);
    } else {
      // for IE
      window.addEventListener("resize", this.resize);
    }
  },
  beforeDestroy() {
    this.removeResizeObserver();
  },
  computed: {
    scale() {
      return d3
        .scaleLinear()
        .domain(this.domain)
        .range([0, this.width]);
    },
    xAxis() {
      let ticks = 4;
      return d3
        .axisBottom(this.scale)
        .ticks(ticks)
        .tickSize(this.height)
        .tickValues(this.tickValues)
        .tickFormat((d) => `${+Math.abs(d).toFixed(0)}%`);
    },
  },
  methods: {
    setSize() {
      const container = this.$refs.container;
      this.width = container.clientWidth;
      this.height = container.clientHeight;
    },
    resize() {
      const currentWidth = this.width;
      const currentHeight = this.height;
      this.setSize();
      if (currentWidth !== this.width || currentHeight !== this.height) {
        this.update();
      }
    },
    update() {
      this.svg.attr("viewBox", [0, 0, this.width, this.height]);

      this.axisContainer
        .call(this.xAxis)
        .call((g) => g.select(".domain").remove())
        .call((g) =>
          g.selectAll("line").attr("stroke-opacity", (d) => {
            if (this.highlightValue !== null) {
              return d === this.highlightValue ? 0.9 : 0.3;
            }
            return 0.3;
          })
        );
    },
    create() {
      this.svg = d3.select(this.$refs.svg);
      //Append group and insert axis
      this.axisContainer = this.svg
        .append("g")
        .attr("transform", `translate(0,4)`);
      this.update();
    },
    removeResizeObserver() {
      if (ResizeObserver) {
        this.resizeObserver.unobserve(this.$refs.container);
      } else {
        // for IE
        window.removeEventListener("resize", this.resize);
      }
    },
  },
};
</script>
<style>
.x-axis {
  overflow: visible !important;
}
</style>
